import { useMutation } from '@apollo/client';
import AddGroupModal from '@components/AddGroupModal';
import DeleteReportModal from '@components/DeleteReportModal';
import ChangeAccessModal from '@components/modals/ChangeAccessModal/ChangeAccessModal';
import RpcProcessModal from '@components/modals/RpcProcessModal';
import AddReportModal from '@modules/reports/components/AddReportModal';
import ReportIntervalSettings from '@modules/reports/components/report-interval-settings/ReportIntervalSettings';
import { CREATE_CONTROL_EXECUTION } from '@shared/api/CreateControlExecution';
import hideIfEmpty from '@utils/hideIfEmpty';
import { loader } from 'graphql.macro';
import { toast } from 'react-hot-toast';
import useHandleCopy from './handlers/useHandleCopy';
import useMenu from './useMenu';

const UNLINK_OBJECT = loader('../../../graphql/UnlinkObject.graphql');

export default function useReportMenu(object) {
  const items = useMenu();
  const handleCopy = useHandleCopy();
  const [createExecution] = useMutation(CREATE_CONTROL_EXECUTION);
  const [unlinkObject] = useMutation(UNLINK_OBJECT);

  const rpcHandler = () => {
    return createExecution({
      variables: {
        input: {
          controlExecution: {
            name: 'CopyReport',
            objectId: object?.id,
            params: {
              UUID: object?.id,
              NAME: `${object?.name} copy`,
            },
          },
        },
      },
    });
  };

  return [
    items.genMenuAddNewContainer({
      disabled: false,
      handleAction: () => {
        AddGroupModal({})
          .then()
          .catch(() => {});
      },
    }),
    { isDivider: true, name: '', id: 'divider' },
    items.genMenuEditItem({
      disabled: false,
      handleAction: () => {
        AddReportModal({
          reportId: object?.id,
        })
          .then()
          .catch(() => {});
      },
    }),
    items.genMenuAccess({
      handleAction: () => {
        ChangeAccessModal({ object }).then();
      },
    }),
    items.genMenuCreateCopy({
      disabled: false,
      handleAction: () => {
        RpcProcessModal({
          objectId: object.id,
          successCb: (id) => {
            if (id) {
              window.location.href = `/reports/${id}`;
            }
          },
          callRpc: rpcHandler,
        }).then();
      },
    }),
    items.genCopyUUID({
      disabled: false,
      handleAction: () => handleCopy({ object }),
    }),
    items.genMenuSettingsItem({
      disabled: false,
      handleAction: () => {
        ReportIntervalSettings({
          reportId: object?.id,
        })
          .then()
          .catch(() => {});
      },
    }),
    items.genMenuDelete({
      disabled: false,
      handleAction: () => {
        DeleteReportModal({
          open: true,
          dashboardId: object?.id,
          name: object?.name,
        })
          .then(() => {})
          .catch(() => {});
      },
    }),

    ...hideIfEmpty(object.linkId, [
      items.genUnlinkItem({
        handleAction: () => {
          toast
            .promise(
              unlinkObject({
                variables: {
                  linkId: object.linkId,
                },
              }),
              {
                loading: 'Unlinking object...',
                success: () => 'Object unlinked',
                error: (err) => `${err.toString()}`,
              }
            )
            .then(() => {});
        },
      }),
    ]),
  ];
}
